export function productSlug(product = {}) {
  if (product.slug) return product.slug;
  try {
    const url = new URL(product.product_url || "", "https://ikoffices.com");
    return url.pathname.match(/^\/p\/([^/]+)$/)?.[1] || "";
  } catch { return ""; }
}

export function comparisonProduct(product) {
  return { ...product, name: product.name || product.title || product.model_name,
    image_url: product.image_url || product.hero_image, slug: productSlug(product),
    _product_type: "page", _product_id: product.id };
}

export function productSaleLabel(product) {
  return product.sale_type === "rental" ? "렌탈" : product.sale_type === "both" ? "구매·렌탈" : "구매";
}

export function productPriceLabel(product) {
  const sale = Number(product.price || 0), rental = Number(product.rental_price || 0);
  const won = value => `${value.toLocaleString()}원`;
  if (product.sale_type === "both") return [sale > 0 && `구매 ${won(sale)}`, rental > 0 && `월 ${won(rental)}`].filter(Boolean).join(" / ") || "가격 문의";
  if (product.sale_type === "rental") return rental > 0 ? `월 ${won(rental)}` : "렌탈료 문의";
  return sale > 0 ? won(sale) : "가격 문의";
}

function specsOf(product) {
  const specs = {};
  function walk(value) {
    if (!value || typeof value !== "object") return;
    Object.entries(value).forEach(([key, item]) => {
      if (key.startsWith("_")) return;
      if (item && typeof item === "object") walk(item);
      else if (typeof item === "string" || typeof item === "number") {
        const text = String(item);
        specs[key.replace(/\s/g, "")] = text;
        const pair = text.match(/^([^:：]+)[:：]\s*(.+)$/);
        if (pair) specs[pair[1].replace(/\s/g, "")] = pair[2];
      }
    });
  }
  walk(product.specs_json);
  return specs;
}

export function productSpec(product, pattern) {
  return Object.entries(specsOf(product)).find(([key]) => pattern.test(key))?.[1] || "";
}

export const COMPARISON_ROWS = [
  { label: "모델명", value: p => p.model_name || productSpec(p, /모델/) },
  { label: "상품 유형", value: productSaleLabel },
  { label: "가격", value: productPriceLabel },
  { label: "브랜드", value: p => p.brand || p.brand_name || productSpec(p, /브랜드|제조사/) },
  { label: "재고", value: p => p.stock_status === "soldout" ? "품절 · 재입고 대기" : p.sale_type === "rental" ? "설치 일정 상담" : "판매 중" },
  { label: "색상·구성", optional: true, value: p => productSpec(p, /색상|컬러여부/) || p.color_type },
  { label: "출력 속도", optional: true, value: p => productSpec(p, /(?:출력|인쇄)속도/) },
  { label: "용지 규격", optional: true, value: p => productSpec(p, /용지규격|지원용지|용지크기/) },
  { label: "출력 매수", optional: true, value: p => productSpec(p, /출력매수|인쇄매수|수율/) },
  { label: "호환 기종", optional: true, value: p => p.compatible_models || productSpec(p, /호환/) },
  { label: "기능", optional: true, value: p => productSpec(p, /^기능$|주요기능/) },
  { label: "조작 패널", optional: true, value: p => productSpec(p, /조작패널/) },
  { label: "기본 제공 매수", optional: true, value: p => productSpec(p, /기본제공매수/) },
];
